import PaymentOrderState from "@/models/Accounts/Shared/PaymentOrders/PaymentOrderState";

export default (paymentOrderState: PaymentOrderState) => {
    let returnVal = "Undefined";
    switch (paymentOrderState) {
        case PaymentOrderState.PendingApproval:
            returnVal = "Pending Approval"
            break;
        case PaymentOrderState.Cancelled:
            returnVal = "Cancelled"
            break;
        case PaymentOrderState.Rejected:
            returnVal = "Rejected"
            break;
        case PaymentOrderState.Submitted:
            returnVal = "Submitted"
            break;
        case PaymentOrderState.Expired:
            returnVal = "Expired"
            break;
    }
    return returnVal;
}